import { grey as greyV1, palette as paletteV1 } from 'src/theme/light/colors';

import { ThemeOptions } from 'src/themeMui5/type';

export const grey: ThemeOptions['grey'] = greyV1;

export const palette: ThemeOptions['palette'] = paletteV1;
